import { render, staticRenderFns } from "./Festivals.vue?vue&type=template&id=4628dd89&scoped=true&"
import script from "./Festivals.vue?vue&type=script&lang=js&"
export * from "./Festivals.vue?vue&type=script&lang=js&"
import style0 from "./Festivals.vue?vue&type=style&index=0&id=4628dd89&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628dd89",
  null
  
)

export default component.exports